import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {
    Divider,
    IconButton,
    TextField,
    Typography,
    FormHelperText,
    Chip,
    Popper,
    Paper,
    Button,
    Breadcrumbs
} from "@mui/material";

import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { getMmrfqDetails } from "../Services/MMRfqForm";
import { Link, useLocation } from "react-router-dom";
import {
    mmRfqAttachmentUploadDrawingFile,
    mmRfqUploadTechDetailsFile
} from "../../Utils/Constant";

const steps = [
    "Confirm RFQ Details & Part Details",
    "Add Documents & Comments",
    "Select Partner"
];

export const MmrfqDetails = () => {
    const location = useLocation();
    const mmrfqID = location?.state?.rfqData;
    const { rfqData, from = "CURFQAssignedToMe" } = location.state || {};

    // console.log("rfqqqqq", mmrfqID);

    const [rows, setRows] = useState<any>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const fetchMmrfqDetails = async () => {
        setIsLoading(true);
        try {
            const response = await getMmrfqDetails(mmrfqID?.mmRfqRowId);
            // console.log("resposeeeee", response);
            if (response?.status) {
                setRows(response?.data[0]);
            } else {
                setRows([]);
            }
        } catch (error) {
            console.error(error);
            setRows([]);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDownloadDrawing = (filePath: string) => {
        if (filePath) {
            const generateUrl = mmRfqAttachmentUploadDrawingFile(filePath);
            // console.log("............", generateUrl);
            const link = document.createElement("a");
            link.href = generateUrl;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleDownloadTechDrawing = (filePath: string) => {
        if (filePath) {
            const generateUrl = mmRfqUploadTechDetailsFile(filePath);
            // console.log("............", generateUrl);
            const link = document.createElement("a");
            link.href = generateUrl;
            link.setAttribute("download", "");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    useEffect(() => {
        if (mmrfqID?.mmRfqRowId) {
            fetchMmrfqDetails();
        }
    }, [mmrfqID]);

    return (
        <>
            <Breadcrumbs aria-label="breadcrumb" sx={{ marginBottom: "10px" }}>
                <Typography sx={{ fontSize: "14px" }}>
                    <Link
                        to="/layout/Dashboard"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Home
                    </Link>
                </Typography>
                {from === "Proposals" ? (
                    <Link
                        to="/layout/Proposals"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Proposals
                    </Link>
                ) : (
                    <Link
                        to="/layout/CURFQAssignedToMe"
                        style={{
                            color: "#0070BA",
                            fontSize: "14px",
                            textDecoration: "none"
                        }}
                    >
                        Assigned CORFQ to Me
                    </Link>
                )}
                {/* <Typography sx={{ fontSize: "14px" }}>
          <Link
            to="/layout/CURFQAssignedToMe"
            style={{
              color: "#0070BA",
              fontSize: "14px",
              textDecoration: "none",
            }}
          >
            Assigned CORFQ to Me
          </Link>
        </Typography> */}
                {[
                    <>
                        <Typography key="final" sx={{ fontSize: "14px" }}>
                            <Link
                                to="/layout/AllMmrfq"
                                style={{
                                    color: "#0070BA",
                                    fontSize: "14px",
                                    textDecoration: "none"
                                }}
                                state={{
                                    rfqData: {
                                        ID: mmrfqID?.ID,
                                        rfqID: mmrfqID?.rfqID
                                    },
                                    from: from
                                }}
                            >
                                All MMRFQs
                            </Link>
                        </Typography>
                    </>
                ]}
                <Typography key="final" sx={{ fontSize: "14px" }}>
                    {mmrfqID?.mmRfqId}
                </Typography>
            </Breadcrumbs>
            <Typography variant="h5" mb={2}>
                MMRFQ Details
            </Typography>
            <Paper sx={{ padding: "15px" }}>
                <Stepper sx={{ paddingTop: "10px", marginBottom: "20px" }}>
                    {steps?.map((label, index) => (
                        <Step key={index} active completed>
                            <StepLabel
                                sx={{
                                    "& .MuiStepIcon-root.Mui-completed": {
                                        color: "green"
                                    }
                                }}
                            >
                                {label}
                            </StepLabel>
                        </Step>
                    ))}
                </Stepper>

                <Typography variant="h6" mb={2} color="primary">
                    Confirmed RFQ Details & Part Details
                </Typography>
                <Typography variant="body1" mb={2}>
                    RFQ Details
                </Typography>

                <Grid container spacing={2} mb={2}>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Customer RFQ Name
                        </Typography>
                        <Typography variant="body1">
                            {rows?.CoRFQ_Name || "-"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            CORFQ ID
                        </Typography>
                        <Typography variant="body1">
                            {rows?.CoRFQ_No || "-"}
                        </Typography>
                    </Grid>

                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            MMRFQ ID
                        </Typography>
                        <Typography variant="body1">
                            {rows?.MMRFQ_ID || "-"}
                        </Typography>
                    </Grid>
                </Grid>

                <Divider />

                <Typography variant="body1" mt={2} mb={2}>
                    Part Details
                </Typography>

                {rows?.Part_Details?.map((part, idx) => {
                    return (
                        <>
                            <div
                                key={idx}
                                style={{
                                    background: "#f5f7f8",
                                    padding: "15px",
                                    marginBottom: "15px"
                                }}
                            >
                                <Typography
                                    sx={{ fontWeight: "bold" }}
                                    variant="body1"
                                >
                                    Part {idx + 1}
                                </Typography>
                                <Grid container spacing={2} mt={1}>
                                    {[
                                        ["Part ID", part?.Part_ID],
                                        ["Part Number", part?.Part_Name],
                                        ["Part Name", part?.Part_Name],
                                        [
                                            "Solutions",
                                            part?.Solutions?.join(", ")
                                        ],
                                        // ["Process", Process],
                                        ["Raw Material", part?.Raw_material],
                                        ["Quantity/Year", part?.Qty_Year],
                                        ["Qty/Batch", part?.Quantity_batch],
                                        ["UOM", part?.UOM],
                                        ["Total Order Value", part?.Total],
                                        ["Type of Order", part?.Type_of_Order],
                                        [
                                            "Mandatory Inspection",
                                            part?.Mandatory_Inspection
                                        ],
                                        ["Packing", part?.Packing],
                                        [
                                            "Sample Required",
                                            part?.Sample_Required
                                        ]
                                    ].map(([label, value], i) => (
                                        <>
                                            <Grid
                                                key={i}
                                                item
                                                xs={12}
                                                md={3}
                                                mb={2}
                                            >
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        color: "text.secondary",
                                                        marginBottom: "0.5rem"
                                                    }}
                                                >
                                                    {label}
                                                </Typography>

                                                <Typography variant="body1">
                                                    {value || "-"}
                                                </Typography>
                                            </Grid>
                                        </>
                                    ))}
                                </Grid>
                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} md={3} mb={2}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "text.secondary",
                                                marginBottom: "0.5rem"
                                            }}
                                        >
                                            Target Price
                                        </Typography>

                                        <Typography variant="body1">
                                            {part?.Target_Price || "-"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} mt={1}>
                                    <Grid item xs={12} md={6} mb={2}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: "text.secondary",
                                                marginBottom: "0.5rem"
                                            }}
                                        >
                                            Uploaded Drawing
                                        </Typography>

                                        <Typography variant="body1">
                                            {part?.Upload_Drawing
                                                ? "Drawing.pdf"
                                                : "-"}

                                            {part?.Upload_Drawing && (
                                                <Button
                                                    size="small"
                                                    variant="outlined"
                                                    sx={{ ml: 2 }}
                                                    onClick={() =>
                                                        handleDownloadDrawing(
                                                            part?.Upload_Drawing
                                                        )
                                                    }
                                                >
                                                    Download
                                                </Button>
                                            )}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </div>
                        </>
                    );
                })}

                <Divider />

                <Typography variant="h6" mb={2} color="primary" mt={2}>
                    Added Documents & Comments
                </Typography>
                <Typography variant="body1" mb={2}>
                    Technical Details
                </Typography>

                <Grid container spacing={2} mb={2} mt={1}>
                    <Grid item xs={12} md={6}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Uploaded Technical Details
                        </Typography>

                        <Typography variant="body1">
                            {rows?.Upload_Technical_Details
                                ? "TechnicalDetails.pdf"
                                : "-"}
                            {rows?.Upload_Technical_Details && (
                                <Button
                                    size="small"
                                    variant="outlined"
                                    sx={{ ml: 2 }}
                                    onClick={() =>
                                        handleDownloadTechDrawing(
                                            rows?.Upload_Technical_Details
                                        )
                                    }
                                >
                                    Download
                                </Button>
                            )}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={2} mb={2} mt={1}>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Compliance Requirements
                        </Typography>

                        <Typography variant="body1">
                            {rows?.Compliance_Requirements || "-"}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Quality Standards
                        </Typography>

                        <Typography variant="body1">
                            {rows?.Quality_Standards || "-"}
                        </Typography>
                    </Grid>
                </Grid>

                <Grid container spacing={2} mb={2} mt={1}>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Comments
                        </Typography>

                        <Typography variant="body1">
                            {rows?.Add_Comments || "-"}
                        </Typography>
                    </Grid>
                </Grid>

                <Divider />

                <Typography variant="h6" mb={2} color="primary" mt={2}>
                    Selected Partners
                </Typography>
                {rows?.Part_Details?.map((partS, idxS) => {
                    return (
                        <Grid key={idxS} container spacing={2} mb={2} mt={1}>
                            <Grid item xs={12} md={6}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "text.secondary",
                                        marginBottom: "0.5rem"
                                    }}
                                >
                                    {partS?.Part_Number} : {partS?.Part_Name}
                                </Typography>

                                {partS?.Select_Partners?.map(
                                    (partner, index) => (
                                        <Typography key={index} variant="body1">
                                            {partner}
                                        </Typography>
                                    )
                                )}
                            </Grid>
                        </Grid>
                    );
                })}

                <Grid container spacing={2} mb={2} mt={1}>
                    <Grid item xs={12} md={3}>
                        <Typography
                            variant="body2"
                            sx={{
                                color: "text.secondary",
                                marginBottom: "0.5rem"
                            }}
                        >
                            Due Date
                        </Typography>

                        <Typography variant="body1">
                            {rows?.Due_Date || "-"}
                        </Typography>
                    </Grid>
                </Grid>
            </Paper>
        </>
    );
};
